import React, { useState, useEffect } from 'react'
import { Input, Table, Button, Modal, Select, Message, message, Form } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
const { Search } = Input
const { Option } = Select
import sysApi from '../../../api/sys'

import './index.scss'

const FlowTmplate = (props) => {
    const [list, setList] = useState([])
    const [modalVisible, setModalVisible] = useState(false)
    const [cateList, setCateList] = useState([])
    const [dictValue, setDictValue] = useState()
    const [updateId, setUpdateId] = useState()
    const [loading, setLoading] = useState(false)
    const [total, setTotal] = useState(0)
    const [updateDictDesc, setUpdateDictDesc] = useState()
    const [updateDictKey, setUpdateDictKey] = useState()
    const [searchParams, setSearchParams] = useState({
        pageNum: 1,
        pageSize: 10
    })

    const getList = () => {
        setLoading(true)
        sysApi.showAllFlowableList({dictType: 'sw-flowable',...searchParams}).then(res => {
            if (res.status !== '0') return
            setLoading(false)
            setList(res.data?.data)
            setTotal(res.data?.total)
        })
    }

    const getAllProcess = () => {
        sysApi.getAllProcess().then(res => {
            if (res.status !== '0') return
            setCateList(res.data)
        })
    }

    const handleTableChange = (pagination) => {
      let params = {
        ...searchParams,
        pageNum: pagination.current,
        pageSize: pagination.pageSize,
      }
      setSearchParams(params)
    }

    const showEdit = (record) => {
      if ( !record.modifyFlag ) return message.error('不可修改，流程模板有待审批事项!')
      setModalVisible(true)
      setUpdateId(record.id)
      setDictValue(record.dictValue)
      setUpdateDictDesc(record.dictDesc)
      setUpdateDictKey(record.dictKey)
    }

    useEffect(() => {
        getList()
    }, [searchParams])

    useEffect( () => {
      getAllProcess()
    }, [])

    const updateProcess = () => {
        const params = {
          dictType: 'sw-flowable',
          dictKey: updateDictKey,
          dictDesc: updateDictDesc,
          dictValue,
          id: updateId
        }
        sysApi.updateFlowable(params).then(res => {
            if (res.status !== '0') return
            Message.success('修改成功')
            setModalVisible(false)
            closeModal()
            getList()
        })
    }

    const closeModal = () => {
      setUpdateDictKey(null)
      setUpdateDictDesc(null)
      setDictValue(null)
      setUpdateId(null)
      setModalVisible(false)
    }

    const columns = [
        {
            title: '序号',
            dataIndex: 'index',
            align: 'center',
            key: 'index',
            render: (_t, record, index) => index + 1
        },
        {
            title: 'dictType',
            dataIndex: 'dictType',
            align: 'center',
            key: 'dictType',
        },
        {
          title: 'dictKey',
          dataIndex: 'dictKey',
          align: 'center',
          key: 'dictKey',
        },
        {
          title: 'dictValue',
          dataIndex: 'dictValue',
          align: 'center',
          key: 'dictValue',
        },
        {
            title: '描述',
            dataIndex: 'dictDesc',
            align: 'center',
            key: 'dictDesc',
            render: _t => _t ? _t : '-'
        },
        {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            key: 'action',
            render: (_, record) => <Button onClick={ () => showEdit(record) } size='small' type="primary" style={{marginRight: 10}}>修改</Button>
        }
    ]

    return (
        <div className='flowTmplate-container'>
            <div className='flowTmplate-search'>
                {/* <Search
                    placeholder="请输入分类名称"
                    allowClear
                    enterButton="搜索"
                    size="large"
                    onSearch={search}
                /> */}
            </div>
            {/* <div className='flowTmplate-btn'>
              <Button type='primary' size='mini'>新增</Button>
            </div> */}
            <div className='flowTmplate-table'>
                <Table
                    loading={loading}
                    rowKey={record => record.id}
                    columns={columns}
                    dataSource={list}
                    pagination={{
                      current: searchParams.pageNum,
                      pageSize: searchParams.pageSize,
                      showQuickJumper: true,
                      showSizeChanger: true,
                      showTotal: total => `共${total}条数据`,
                      total: total
                    }}
                    onChange={handleTableChange}
                />
            </div>
            <Modal
                title="修改流程分类"
                open={modalVisible}
                onCancel={closeModal}
                onOk={ updateProcess }
            >
                <div className='flowTmplate-modify-modal'>
                    <span>流程分类：</span>
                    <Select placeholder="请选择流程分类" value={dictValue} onChange={ e => setDictValue(e)}>
                        { cateList.length > 0 && cateList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>) }
                    </Select>
                </div>
            </Modal>
        </div>
    )
}

export default FlowTmplate